/**
 * @file
 * Video Mute Toggle functionality for Homepage Video Carousel
 *
 * Handles muting/unmuting of videos in both carousel and standalone contexts.
 * Works with HTML5 video elements and YouTube iframes.
 */

(function (Drupal, $) {
  'use strict';

  Drupal.behaviors.videoMuteToggle = {
    attach: function (context, settings) {
      // Initialize mute toggle button
      $('#muteToggle', context).once('video-mute-toggle').each(function() {
        $(this).on('click', toggleMute);
      });
    }
  };

  function toggleMute() {
    // Check if we're in a carousel context
    var activeSlide = document.querySelector('.homepage-video-carousel .splide__slide.is-active');
    var carouselVideo = activeSlide ? activeSlide.querySelector('video') : null;
    var carouselIframe = activeSlide ? activeSlide.querySelector('iframe') : null;

    // Fallback to old video ID if not in carousel
    var video = carouselVideo || document.getElementById("myVideo");

    // Handle HTML5 video
    if (video) {
      if (video.muted) {
        video.muted = false;
        document.getElementById("mutesvg").style.display = "none";
        document.getElementById("unmute-svg").style.display = "block";
      } else {
        video.muted = true;
        document.getElementById("mutesvg").style.display = "block";
        document.getElementById("unmute-svg").style.display = "none";
      }
    }
    // Handle YouTube iframe
    else if (carouselIframe) {
      var src = carouselIframe.src;
      if (src.includes('youtube.com') || src.includes('youtu.be')) {
        // Check current mute state from display
        var muteIcon = document.getElementById("mutesvg");
        var isMuted = muteIcon.style.display !== "none";

        if (isMuted) {
          // Unmute
          carouselIframe.contentWindow.postMessage('{"event":"command","func":"unMute","args":""}', '*');
          document.getElementById("mutesvg").style.display = "none";
          document.getElementById("unmute-svg").style.display = "block";
        } else {
          // Mute
          carouselIframe.contentWindow.postMessage('{"event":"command","func":"mute","args":""}', '*');
          document.getElementById("mutesvg").style.display = "block";
          document.getElementById("unmute-svg").style.display = "none";
        }
      }
    }
  }

})(Drupal, jQuery);
